<app-invoice-filters
  [filters]="filters()"
  [statusOptions]="statusOptionsForFilter()"
  (toggleSortOrder)="toggleSortOrder()"
  (resetFilters)="resetFilters()"
  (applyFilters)="applyFilters($event)"
  (selectPharmacy)="selectPharmacy($event)" />

<app-invoice-table
  [invoices]="invoices()"
  [state]="state()"
  [errorMessage]="errorMessage()"
  [currentPage]="currentPage()"
  [totalItems]="totalItems()"
  [itemsPerPage]="itemsPerPage()"
  [totalPages]="totalPages"
  [isFiltersApplied]="isFiltersApplied()"
  (pageChange)="onPageChange($event)"
  (pageSizeChange)="onPageSizeChange($event)"
  (rowClick)="navigateToDetails($event)"
  (getInvoices)="loadInvoices()" />
